exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".player-poster[data-poster]{position:absolute;height:100%;width:100%;z-index:998;top:0;left:0;display:flex;justify-content:center;align-items:center;background-color:#000;background-size:cover;background-repeat:no-repeat;background-position:50% 50%}.player-poster[data-poster].clickable{cursor:pointer}.player-poster[data-poster]:hover .play-wrapper[data-poster]{opacity:1}.player-poster[data-poster] .play-wrapper[data-poster]{width:100%;height:25%;margin:0 auto;opacity:.75;-webkit-transition:opacity .1s ease;transition:opacity .1s ease}.player-poster[data-poster] .play-wrapper[data-poster] svg{height:100%}.player-poster[data-poster] .play-wrapper[data-poster] svg path{fill:#fff}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./src/plugins/poster/public/poster.scss
 ** module id = 132
 ** module chunks = 0
 **/